import { Currencies } from '@/entities/curency'
import { Roles } from '@/entities/roles'
import { USER_ROLE_KEY } from '@/features/auth'
import { getStorageItem } from '@/shared/lib/storage/localStorage'

const WITHDRAWS_ENDPOINTS: Partial<Record<Roles, string>> = {
  [Roles.Trader]: '/v1/trader',
  [Roles.Merchant]: '/v1/merchant/withdraws',
} as const

// Функция для получения актуального endpoint
const getEndpoint = (): string => {
  const userRole = getStorageItem<Roles | null>(USER_ROLE_KEY, null)
  return userRole ? WITHDRAWS_ENDPOINTS[userRole]! : WITHDRAWS_ENDPOINTS[Roles.Trader]!
}

export const withdrawsAPIMerchant = {
  get endpoint() {
    return getEndpoint()
  },
  get list() {
    return getEndpoint()
  },
  item: (id: string) => {
    const endpoint = getEndpoint()
    return `${endpoint}/${id}`
  },
  get create() {
    return getEndpoint()
  },
}

export const withdrawsAPITrader = {
  get countries() {
    return '/v1/outgoingpaymentchannels/countries'
  },
  get banks() {
    return '/v1/outgoingpaymentchannels/banks'
  },
  item: (id: string) => {
    return `/v1/trader/withdraws/${id}`
  },
  getChannels: ({
    country,
    currency,
  }: {
    country: string
    currency: Currencies.RUB | Currencies.USDT
  }) => {
    const endpoint = getEndpoint()
    return `${endpoint}/withdrawbalanceandchannels/${country}/${currency}`
  },
  get updateChannels() {
    const endpoint = getEndpoint()
    return `${endpoint}/withdrawbalanceandchannels`
  },
  // Новый единый эндпоинт для всех статусов
  get list() {
    const endpoint = getEndpoint()
    return `${endpoint}/withdraws`
  },
  // Старые эндпоинты (оставлены для обратной совместимости, если нужно)
  get listAssigned() {
    const endpoint = getEndpoint()
    return `${endpoint}/withdraws/assigned`
  },
  get listAccepted() {
    const endpoint = getEndpoint()
    return `${endpoint}/withdraws/accepted`
  },
  get listPaid() {
    const endpoint = getEndpoint()
    return `${endpoint}/withdraws/paid`
  },
  getPaidWithdraw(withdrawId: string) {
    const endpoint = getEndpoint()
    return `${endpoint}/withdraws/paid/${withdrawId}`
  },
  get acceptWithdraw() {
    const endpoint = getEndpoint()
    return `${endpoint}/withdraws/accept`
  },
  getActiveWithdraw(withdrawId: string) {
    const endpoint = getEndpoint()
    return `${endpoint}/withdraws/startpaying/${withdrawId}`
  },
  get confirmPayment() {
    const endpoint = getEndpoint()
    return `${endpoint}/withdraws/confirm`
  },
  get declineWithdraw() {
    const endpoint = getEndpoint()
    return `${endpoint}/withdraws/decline`
  },
  get attachReceipt(): string {
    const endpoint = getEndpoint()
    return `${endpoint}/withdraws/attachreceipt`
  },
  getReceipts(withdrawId: string): string {
    const endpoint = getEndpoint()
    return `${endpoint}/withdraws/${withdrawId}/receipts`
  },
  get deleteReceipt(): string {
    const endpoint = getEndpoint()
    return `${endpoint}/withdraws/deletereceipt`
  },
}
